<template>
  <div class="coverShow" v-show="visible">
    <div class="container-gj" @click="cancelClick">
      <div class="container-gd">
        <div class="modal-content" @click.stop>
          <div class="header-view">
            <span
              style="
                font-size: 18px;
                font-weight: 600;
                color: #2b2f36;
                line-height: 24px;
              "
              >设置测评结果</span
            >
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              @click="cancelClick"
              style="width: 13px; height: 13px; cursor: pointer"
            />
          </div>
          <div class="evaluation-result-page">
            <!-- 不显示分数开关 -->
            <div class="show-section">
              <span class="title">不显示分数</span>
              <el-switch
                v-model="ifShowAssessmentScore"
                active-value="0"
                inactive-value="1"
                active-color="#59D27B"
                @change.stop
              ></el-switch>
            </div>

            <!-- 分数范围列表 -->
            <div
              v-for="(item, index) in resultList"
              :key="index"
              class="evaluation-container"
            >
              <!-- 分数范围输入区域 -->
              <div class="score-range-section">
                <div class="input-wrapper">
                  <span>在</span>
                  <input
                    type="number"
                    maxlength="4"
                    v-model.number="item.minScore"
                    class="score-range-input"
                    placeholder="始分分数"
					@keydown="preventDecimal"
                    @blur="validateScore(item)"
                  />
                  <span>-</span>
                  <input
                    type="number"
                    maxlength="4"
                    v-model.number="item.maxScore"
                    class="score-range-input"
                    placeholder="结束分数"
					@keydown="preventDecimal"
                    @blur="validateScore(item)"
                  />
                  <span>范围内时</span>
                </div>
                <i
                  class="el-icon-delete del-icon"
                  @click="delResultItem(index)"
                ></i>
              </div>

              <!-- 测评结果输入区域 -->
              <div class="result-section">
                <span class="section-title">测评结果标题</span>
                <input
                  type="text"
                  class="result-input"
                  placeholder="请输入评测结果标题，建议10个字以内"
                  v-model="item.resultContent"
                />
              </div>

              <!-- 测评详情文本域 -->
              <div class="detail-section">
                <span class="section-title">测评详情</span>
                <div class="detail-textarea">
                  <textarea
                    class="textarea"
                    maxlength="500"
                    v-model="item.resultDetail"
                    @focus="item._focus = true"
                    @blur="item._focus = false"
                  ></textarea>
                  <div
                    class="placeholder"
                    v-if="!item.resultDetail && !item._focus"
                  >
                    请填写在该分数段内,测评的详细情况
                  </div>
                </div>
                <span class="word-count"
                  >{{ item.resultDetail.length }}/500</span
                >
              </div>

              <!-- 图片/视频上传区域 -->
              <span class="section-title"> 图片/视频<span>(选填)</span> </span>
              <!-- 已上传的媒体列表 -->
              <div
                v-for="(optItem, optIdx) in item.mediaUrls"
                :key="optIdx"
                class="upload-section"
              >
                <div
                  v-if="getMediaType(optItem) === 'image'"
                  class="image-view"
                >
                  <i
                    class="el-icon-close del"
                    @click.stop="delItem(index, optIdx)"
                  ></i>
                  <img
                    :src="optItem"
                    class="img"
                    @click="showBigImage(optItem)"
                  />
                </div>
                <div
                  v-else-if="getMediaType(optItem) === 'video'"
                  class="image-view"
                >
                  <i
                    class="el-icon-close del"
                    @click.stop="delItem(index, optIdx)"
                  ></i>
                  <video
                    :src="optItem"
                    style="width: 100%; height: 200px"
                    controls
                  ></video>
                </div>
              </div>
              <!-- 上传按钮 -->
              <div
                v-if="item.mediaUrls.length < 4"
                class="upload-area"
                @click="handleItemImage(index)"
              >
                <div class="plus-icon"></div>
                <span class="upload-text">点击上传图片/视频</span>
                <!-- Web端隐藏的文件选择框 -->
                <input
                  ref="fileInput"
                  type="file"
                  class="file-input"
                  accept="image/*,video/*"
                  @change="handleFileChange(index, $event)"
                />
              </div>
              <span class="upload-tip">最多可上传3张图片,1个视频</span>
            </div>

            <button class="add-button" @click="addScoreRange">
              添加分数范围
            </button>

            <!-- 底部按钮 -->
            <div class="bottom-button-section">
              <button class="close-button" @click="cancelClick">取消</button>
              <button class="save-button" @click="saveScoreRange">保存</button>
            </div>

            <!-- 替换 PopupPrompt：确认弹窗 -->
            <el-dialog
              :title="promptTitle"
              :visible.sync="showPrompt"
              @close="handlePromptCancel"
            >
              <span>{{ promptContent }}</span>
              <div slot="footer" class="dialog-footer">
                <el-button @click="handlePromptCancel">{{
                  promptCancel
                }}</el-button>
                <el-button type="primary" @click="handlePromptConfirm">{{
                  promptConfirm
                }}</el-button>
              </div>
            </el-dialog>

            <!-- 图片预览弹窗 -->
            <el-dialog
              title="图片预览"
              :visible.sync="showImagePreview"
              width="50%"
            >
              <img :src="previewImageUrl" style="width: 100%" />
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// 引入基础地址（需和项目一致）
import baseURL from "../../utils/bsaeUrl";
export default {
  name: "EvaluationResult",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      uuid: "",
      startScore: "",
      endScore: "",
      // 当前上传的索引
      uploadIndex: -1,
      // 结果列表
      resultList: [],
      // 是否显示测评分数 0不显示 1显示
      ifShowAssessmentScore: "1",
      // 导航栏标题
      navigateTitle: "设置测评结果",
      // 确认弹窗配置
      showPrompt: false,
      promptTitle: "",
      promptContent: "",
      promptConfirm: "确定",
      promptCancel: "取消",
      // 图片预览
      showImagePreview: false,
      previewImageUrl: "",
      visible: false,
    };
  },
  watch: {
    show(newVal) {
      this.visible = newVal;
    },
    params: {
      handler(newVal) {
        if (newVal) {
          console.log("fweufgyegfewyge1e1y2ey12e12e1", newVal);
          this.uuid = newVal.uuid;
          this.ifShowAssessmentScore = newVal.ifShowAssessmentScore;
          // 解析测评结果列表
          if (newVal.assessmentResults) {
            this.resultList = newVal.assessmentResults.map((item) => ({
              ...item,
              minScore: Number(item.minScore),
              maxScore: Number(item.maxScore),
              mediaUrls:
                item.mediaUrls.split(",").filter((url) => url !== "") || [],
              _focus: false, // 文本域聚焦状态
            }));
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    // 弹窗取消按钮
    handlePromptCancel() {
      // this.showPrompt = false;
      // this.$router.go(-1);
      this.$emit("close");
    },
    // 弹窗确认按钮
    handlePromptConfirm() {
      // this.showPrompt = false;

      const list = this.resultList.map((item) => ({
        ...item,
        resultDetail: item.resultDetail || "请填写在该分数段内,测评的详细情况",
        mediaUrls: Array.isArray(item.mediaUrls)
          ? item.mediaUrls.join(",")
          : item.mediaUrls || "",
      }));
      this.$emit("confirm", {
        ifShowAssessmentScore: this.ifShowAssessmentScore,
        assessmentResults: list,
      });

      // this.$router.go(-1);
    },
	preventDecimal(e) {
		if (e.key === '.' || e.key === 'e' || e.key === '-') {
			e.preventDefault()
		}
	},
    // 校验分数（起始和结束不能相同）
    validateScore(item) {
      if (
        item.minScore != null &&
        item.maxScore != null &&
        item.minScore === item.maxScore
      ) {
        this.$message.warning("起始分数和结束分数不能相同");
        item.maxScore = null;
      }
    },
    // 添加分数范围
    addScoreRange() {
      this.resultList.push({
        resultTitle: "",
        resultContent: "",
        resultDetail: "",
        minScore: 1,
        maxScore: 100,
        mediaUrls: [],
        _focus: false,
      });
    },
    // 保存分数范围
    saveScoreRange() {
      console.log(this.resultList);
      console.log("resultList.length;", this.resultList.length);
      // 基础校验
      for (let i = 0; i < this.resultList.length; i++) {
        if (
          Number(this.resultList[i].minScore) >=
          Number(this.resultList[i].maxScore)
        ) {
          this.$message.warning("请输入正确的分数范围");
          return;
        }
        if (!this.resultList[i].resultContent) {
          this.$message.warning("请输入测评结果标题");
          return;
        }
        if (!this.resultList[i].resultDetail) {
          this.$message.warning("请输入测评详情");
          return;
        }
      }

      // 检查分数范围交集
      for (let i = 0; i < this.resultList.length; i++) {
        for (let j = i + 1; j < this.resultList.length; j++) {
          const range1 = {
            min: Number(this.resultList[i].minScore),
            max: Number(this.resultList[i].maxScore),
          };
          const range2 = {
            min: Number(this.resultList[j].minScore),
            max: Number(this.resultList[j].maxScore),
          };

          if (!(range1.max < range2.min || range2.max < range1.min)) {
            this.$message.warning("分数范围重复，请重新设置");
            return;
          }
        }
      }

      // 处理媒体地址
      const list = this.resultList.map((item) => {
        return {
          ...item,
          mediaUrls: item.mediaUrls.join(","),
        };
      });

      // 传递数据并返回
      this.$emit("confirm", {
        ifShowAssessmentScore: this.ifShowAssessmentScore,
        assessmentResults: list,
      });
      // this.$router.go(-1);
    },
    // 点击上传按钮（打开文件选择框）
    handleItemImage(index) {
      this.uploadIndex = index;
      this.$refs.fileInput.click();
    },
    // 处理文件选择（Web端核心）
    handleFileChange(index, e) {
      const file = e.target.files[0];
      if (!file) return;

      // 校验文件类型
      const isImage = file.type.startsWith("image/");
      const isVideo = file.type.startsWith("video/");
      if (!isImage && !isVideo) {
        this.$message.warning("请选择图片或视频文件");
        return;
      }

      // 校验数量限制
      const mediaList = this.resultList[index].mediaUrls;
      const imageCount = this.getImageCount(mediaList);
      const videoCount = this.getVideoCount(mediaList);

      if (isImage && imageCount >= 3) {
        this.$message.warning("图片数量不能超过3张");
        return;
      }
      if (isVideo && videoCount >= 1) {
        this.$message.warning("视频数量不能超过1个");
        return;
      }

      // 校验文件大小（50MB）
      const maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message.warning("文件大小不能超过50MB");
        return;
      }

      this.uploadFile(this.uploadIndex, file);

      // 压缩并上传
      // this.compressAndUploadFile(index, file, isImage);
    },
    // 压缩并上传文件（Web端简化版）
    compressAndUploadFile(index, file, isImage) {
      this.$loading({ text: isImage ? "图片上传中" : "视频上传中" });

      // Web端图片压缩（canvas实现）
      if (isImage) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            // 压缩比例（80%质量）
            const quality = 0.8;
            // 保持宽高比
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            // 转换为blob
            canvas.toBlob(
              (blob) => {
                this.uploadFile(
                  index,
                  new File([blob], file.name, { type: file.type }),
                );
              },
              file.type,
              quality,
            );
          };
        };
        reader.readAsDataURL(file);
      } else {
        // 视频压缩：Web端无原生API，直接上传
        this.uploadFile(index, file);
      }
    },
    uploadFile(index, file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("uuid", localStorage.getItem("uuid") || this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(`${baseURL}/wj/file/uploads`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.$loading().close();

          if (res.data.code === 200) {
            this.resultList[index].mediaUrls.push(res.data.urls);
            this.$message.success("上传成功");
          } else {
            console.error("上传失败：", res);
            this.$message.error("上传失败，请重试");
          }
        })
        .catch((err) => {
          this.$loading().close();
          console.error("上传失败：", err);
          this.$message.error("上传失败，请重试");
        });
    },
    // 获取媒体类型
    getMediaType(option) {
      const url = option.split("?")[0];
      const type = url.split(".").pop().toLowerCase();
      const imageTypes = ["jpg", "jpeg", "png", "svg"];
      const videoTypes = ["mp4", "avi", "mov", "wmv", "flv"];
      if (imageTypes.includes(type)) return "image";
      if (videoTypes.includes(type)) return "video";
      return "unknown";
    },
    // 获取图片数量
    getImageCount(list) {
      let count = 0;
      for (let i = 0; i < list.length; i++) {
        if (this.getMediaType(list[i]) === "image") count++;
      }
      return count;
    },
    // 获取视频数量
    getVideoCount(list) {
      let count = 0;
      for (let i = 0; i < list.length; i++) {
        if (this.getMediaType(list[i]) === "video") count++;
      }
      return count;
    },
    // 删除分数范围项
    delResultItem(index) {
      this.resultList.splice(index, 1);
    },
    // 删除媒体项
    delItem(index, optIdx) {
      this.resultList[index].mediaUrls.splice(optIdx, 1);
    },
    // 预览大图
    showBigImage(url) {
      this.previewImageUrl = url;
      this.showImagePreview = true;
    },
    cancelClick() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 10000000;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 500px;
  background: #ffffff;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.modal-content {
  width: 100%;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.bg-view {
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}

.header-view {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  padding: 0 12px;
  box-sizing: border-box;
}

.body-view {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.input-container {
  height: 40px;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  padding: 0 12px;
  box-sizing: border-box;
}

.input-container-input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-size: 14px;
}

.btn-view {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-top: 1px solid #e7e7e7;
}

.cancel {
  width: 48%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border: 1px solid #3a60ff;
  border-radius: 4px;
  color: #3a60ff;
  cursor: pointer;
}

.confirm {
  width: 48%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #3a60ff;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

// rpx转px：1rpx = 0.5px
.evaluation-result-page {
  padding: 10px;
  box-sizing: border-box;
  background: #f5f5f5;
  height: 60vh;
  overflow-y: auto;
  // min-height: 100vh;
}

.evaluation-container {
  width: 100%;
  padding: 12.5px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px dashed #3a60ff;
  border-radius: 5px;
  margin-top: 10px;
}

.score-range-section {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  .del-icon {
    color: #f73b42;
    font-size: 14px;
    cursor: pointer;
    margin-left: 15px;
  }
}

.input-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
  padding: 8px 10px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin-right: 15px;
}

.score-range-input {
  width: 60px;
  border-radius: 6px;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  border: none;
  outline: none;
}

.section-title {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #323b5a;
  margin-bottom: 10px;
}

.show-section {
  padding: 0 12.5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  margin-bottom: 10px;
  .title {
    display: block;
    font-size: 16px;
    font-weight: 600;
    color: #323b5a;
  }
}

.result-section {
  margin-bottom: 15px;
}

.result-input {
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 15px;
  color: #333333;
  padding: 8px 10px;
  outline: none;
}

.detail-section {
  margin-bottom: 15px;
  position: relative;
}

.detail-textarea {
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  position: relative;
  .textarea {
    width: 100%;
    min-height: 100px;
    padding: 5px 9px 9px;
    font-size: 15px;
    color: #333333;
    box-sizing: border-box;
    resize: none;
    text-align: justify;
    border: none;
    outline: none;
  }
  .placeholder {
    position: absolute;
    top: 10px;
    left: 10px;
    color: #979eae;
    font-size: 15px;
    pointer-events: none;
  }
}

.word-count {
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 12px;
  color: #999999;
}

.upload-section {
  margin-bottom: 20px;
}

.upload-area {
  width: 100%;
  height: 191px;
  border-radius: 6.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fafafa;
  cursor: pointer;
  position: relative;
  // 隐藏文件选择框
  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}

.upload-text {
  font-size: 15px;
  color: #798497;
  font-weight: 400;
  margin-top: 5px;
}

.bottom-button-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  // margin-top: 15px;
  gap: 10px;
}

.close-button {
  flex: 1;
  height: 44px;
  line-height: 44px;
  background-color: #ffffff;
  text-align: center;
  color: #3a60ff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid #3a60ff;
  cursor: pointer;
}

.add-button {
  height: 44px;
  line-height: 44px;
  background-color: #ffffff;
  text-align: center;
  color: #3a60ff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid #3a60ff;
  cursor: pointer;
  margin: 10px auto;
  width: 100%;
}

.save-button {
  flex: 1;
  height: 44px;
  line-height: 44px;
  background-color: #3a60ff;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid #3a60ff;
  cursor: pointer;
}

.plus-icon {
  position: relative;
  width: 30px;
  height: 30px;
  margin-top: 58.5px;
  margin-bottom: 5px;
  &::before,
  &::after {
    content: "";
    position: absolute;
    background-color: #b2b7bf;
  }
  &::before {
    left: 50%;
    top: 0;
    width: 3px;
    height: 100%;
    transform: translateX(-50%);
  }
  &::after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 3px;
    transform: translateY(-50%);
  }
}

.image-view {
  width: 100%;
  background: #f4f4f4;
  border-radius: 6.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
  .img {
    width: 100%;
    height: auto;
  }
  .del {
    position: absolute;
    top: 7.5px;
    right: 7.5px;
    width: 20px;
    height: 20px;
    z-index: 10;
    color: #f73b42;
    font-size: 16px;
    cursor: pointer;
  }
}

.upload-tip {
  font-weight: 400;
  text-align: left;
  color: #f73b42;
  margin-top: 5px;
  font-size: 11px;
  display: block;
}

// 上传选项弹窗样式
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .el-button {
    text-align: left;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SetEvaluationResult/index.vue